import React, { useState } from 'react';
import { IBreadcrumb } from '@/components/common/breadcrumbs';

export interface IBreadcrumbContextType {
  breadcrumbs: IBreadcrumb[];
  setBreadcrumbs: (items: IBreadcrumb[]) => void;
}

export const BreadcrumbContext =
  React.createContext<IBreadcrumbContextType | null>(null);

interface IBreadcrumbProvider {
  children?: React.ReactNode;
}

const BreadcrumbProvider: React.FC<IBreadcrumbProvider> = ({ children }) => {
  const [breadcrumbs, setBreadcrumbsItems] = useState<IBreadcrumb[]>([]);

  const setBreadcrumbs = (items: IBreadcrumb[]) => {
    setBreadcrumbsItems(items);
  };

  return (
    <BreadcrumbContext.Provider value={{ breadcrumbs, setBreadcrumbs }}>
      {children}
    </BreadcrumbContext.Provider>
  );
};

export default BreadcrumbProvider;
